/**
 * 한글의 인코딩 문제로 s3에 파일 업로드시 파일 이름에 대한 인코딩 과정이 필요합니다.
 * 인코딩 방식은 s3 삭제 마커가 NFD 방식으로 파일을 생성하기 때문에
 * NFD 방식으로 통일합니다.
 * @param string
 */

export const normalizeToNFD = (string: string) => {
  return string?.normalize("NFD");
};

/**
 * 파일명이 한글인 경우, 윈도우에서 파일을 다운로드할 때 파일명이
 * "ㅁㅜㄴㅈㅔ"처럼 깨져서 다운로드되는 문제가 발생할 수 있습니다.
 * 이를 해결하기 위해 파일명을 NFC 방식으로 정규화하여
 * 안정적으로 다운로드할 수 있도록 합니다.
 * @param string
 */
export const normalizeToNFC = (string: string) => {
  return string?.normalize("NFC");
};
